import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { AgentSwitchField } from 'entities/AIAgent/ui/AgentSwitchField/AgentSwitchField'
import { type RequestAttachment } from 'entities/Attachment/model/RequestAttachment.ts'
import { Attachment } from 'entities/Attachment/model/Attachment.ts'
import { type IMessageFieldProps, MessageField, type MessageFieldStore } from 'widgets/MessageField'
import { MessageModalActions } from 'widgets/TemplateActions/ui/MessageModalActions/MessageModalActions.tsx'

import styles from './styles.module.scss'

export type IMessageContentData = { auto: boolean; message: string; media_url: RequestAttachment[] }

export type IMessageContentProps = {
  messageFieldStore: MessageFieldStore
  title: string
  questionInfoTooltip: string

  onClose: () => void
  onSave: (data: IMessageContentData) => void
  data?: IMessageContentData
  onDelete?: () => void
  color?: IMessageFieldProps['color']
}

export const MessageContent = observer(
  ({
    messageFieldStore,
    title,
    questionInfoTooltip,
    onSave,
    onClose,
    onDelete,
    color,
    data,
  }: IMessageContentProps) => {
    const [isAuto, setIsAuto] = useState<boolean>(data?.auto ?? false)

    useEffect(() => {
      const attachments =
        data?.media_url?.map(
          (item) => new Attachment({ requestAttachment: item, fromMediaUrl: true })
        ) ?? []
      messageFieldStore.setMessageData({
        message: data?.message ?? '',
        attachments,
        isReset: false,
        isReplace: true,
        isFocus: true,
      })
    }, [data])

    const handleSave = () => {
      onSave(
        isAuto
          ? { auto: true, message: '', media_url: [] }
          : {
              auto: false,
              message: messageFieldStore.text.trim(),
              media_url: messageFieldStore.media_url,
            }
      )
      onClose()
    }

    const handleDelete = onDelete
      ? () => {
          onDelete()
          onClose()
        }
      : undefined

    const disabledSave = isAuto
      ? false
      : (!messageFieldStore.text.trim() && !messageFieldStore.media_url.length) ||
        messageFieldStore.loadingAttachment

    return (
      <>
        <div className={styles.content}>
          <div onMouseDown={(e) => e.stopPropagation()}>
            <AgentSwitchField
              title={title}
              active={isAuto}
              onChange={setIsAuto}
              questionInfoTooltipProps={{ label: questionInfoTooltip, width: 210 }}
            />
          </div>
          {!isAuto && <MessageField messageFieldStore={messageFieldStore} color={color} />}
        </div>
        <MessageModalActions
          onDelete={handleDelete}
          onSave={handleSave}
          onCancel={onClose}
          disabledSave={disabledSave}
        />
      </>
    )
  }
)
